/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import { Modal } from "react-bootstrap";
import { qreq } from "../../shared/qrequest";
import AppActions from "../AppActions";
import BaseCom from "../BaseCom";
import Card from "../Card";
import FormInput from "../FormInput";
import Icon from "../Icon";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";

class PanelManageEdit extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            item: {
                targets: []
            },
            example: {
                name: 'Complete Blood Count with Differential',
                code: 'CBCD',
                shortName: 'CBC Diff'
            }
        }
    }

    componentDidMount() {
        this.fillList('/api/productline/list', 'productLines');
        this.fillList('/api/target/list', 'targets');

        if (this.props.params.id) {
            this.fillItem('/api/panel/get/' + this.props.params.id, 'item');
        }
    }

    change = () => {
        this.setState({ item: { ...this.state.item } });
    }

    toggleTarget = (target) => {
        var i = this.state.item.targets.findIndex(t => t.id === target.id);
        if (i === -1)
            this.state.item.targets.push(target);
        else
            this.state.item.targets.splice(i, 1);
        this.change();
    }

    getSelectedTarget = (id) => {
        return this.state.item.targets.find(t => t.id === id);
    }

    filterTargets = () => {
        return this.state.targets?.filter(a => !this.state.targetSearch || a.name.toLowerCase().trim().indexOf(this.state.targetSearch.toLowerCase().trim()) >= 0);
    }

    // Suggest AI

    suggest = async () => {
        this.setState({ suggesting: true });
        let productLine = this.state.productLines.find(i => i.id === Number(this.state.item.productLineID));
        let productLineName = productLine.name;
        let panelName = this.state.item.name;
        try {
            let j = await qreq.getAsync(`/api/panel/suggest-targets?productLineName=${productLineName}&panelName=${panelName}`);
            if (j.list) {
                this.setState({ suggestedTargets: j.list, showSuggest: true });
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback();
        }
        this.setState({ suggesting: false });
    }

    selectAllSuggested = (e) => {
        let list = [...this.state.suggestedTargets];
        list.forEach(i => i.selected = e.target.checked);
        this.setState({ suggestedTargets: list });
    }

    commitSuggested = async (e) => {
        e?.preventDefault();
        this.setState({ suggestProcessing: true });
        let list = this.state.suggestedTargets.filter(i => i.selected);
        let created = [];
        for(let n = 0; n < list.length; n++) {
            let i = list[n];
            try
            {
                let j = await qreq.postAsync('/api/target/save', i);
                if (j.errorCode === 0) {
                    created.push(j.item);
                }
                else if(j.errorCode === 7) {
                    created.push(j.item);
                }
                else
                    this.alert(j.errorMessage);
                console.log('created', created);
            }
            catch
            {
                this.unkownErrorCallback();
            }
        }
        this.setState({ showSuggest: false });
        await this.fillListAsync('/api/target/list', 'targets');
        setTimeout(() => {
            created.forEach(i => {
                let find = this.state.targets.find(t => t.id === i.id);
                this.toggleTarget(find);
            });
        }, 100);
        this.setState({ suggestProcessing: false });
    }

    toggleSuggestedTarget(e, target) {
        target.selected = e.target.checked;
        this.setState({ suggestedTargets: this.state.suggestedTargets });
    }

    submit = async (e) => {
        try {
            e?.preventDefault();
            let j = await qreq.postAsync('/api/panel/save', this.state.item);
            if (j.errorCode === 0) {
                this.success('Panel saved');
                this.goBack();
            }
            else
                this.alert('Error saving panel');
        }
        catch (e) {
            this.alert(e);
        }
    }

    render() {
        return <div className="container-fluid">
            <Modal show={this.state.showSuggest} onHide={() => this.setState({ showSuggest: false })}>
                <Modal.Header closeButton>
                    Suggested Targets
                </Modal.Header>
                <form onSubmit={this.commitSuggested}>
                    <Modal.Body>
                        {this.state.suggestedTargets && <div className="overflow-list">
                            <ul className="list-group no-select">
                                <li className="list-group-item d-flex">
                                    <input type="checkbox" className="d-block" onClick={this.selectAllSuggested} />
                                    <div className="ms-2 flex-fill">
                                        Select All
                                    </div>
                                </li>
                                {this.state.suggestedTargets.map((i,idx) => <li role="button" key={idx} onClick={() => { }} className={'list-group-item d-flex'}>
                                    <input type="checkbox" className="d-block" checked={i.selected} onChange={(e) => this.toggleSuggestedTarget(e,i)} />
                                    <div className="ms-2 flex-fill">
                                        {i.name}
                                    </div>
                                    <div className="ms-2">
                                        {i.code}
                                    </div>
                                </li>)}
                            </ul>
                        </div>}
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="submit" className="btn btn-success" disabled={this.state.suggestProcessing}>{this.state.suggestProcessing && <Icon icon="faWandMagicSparkles" spin />} Apply</button>
                        <button type="button" className="btn btn-secondary" onClick={() => this.setState({ showSuggest: false })} disabled={this.state.suggestProcessing}>Close</button>
                    </Modal.Footer>
                </form>
            </Modal>
            <form onSubmit={this.submit}>
                <h1>Panel</h1>
                <Card title="Basic Information">
                    <div className="row">
                        <div className="col-md-5">
                            <FormInput model={this.state.item} name="name" label="Name" required placeholder={this.state.example.name} onChange={this.change} />
                        </div>
                        <div className="col-md-2">
                            <FormInput model={this.state.item} name="code" label="Code" required placeholder={this.state.example.code} onChange={this.change} />
                        </div>
                        <div className="col-md-5">
                            <FormInput model={this.state.item} name="shortName" label="Short Name" placeholder={this.state.example.shortName} onChange={this.change} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <FormInput model={this.state.item} name="productLineID" label="Product Line" type="select" options={this.state.productLines ?? []} onChange={this.change} required />
                        </div>
                    </div>
                    {this.state.item.name && this.state.item.productLineID && <>
                        <button type="button" className="btn btn-primary" onClick={() => this.suggest()}><Icon icon="faWandMagicSparkles" spin={this.state.suggesting} /> Suggest Targets</button>
                    </>}
                </Card>
                <Card title="Targets">
                    <input type="text" className="form-control mb-1" placeholder="Search targets..." onChange={(e) => this.setState({ targetSearch: e.target.value })} />
                    <div className="overflow-list">
                        <ul className="list-group no-select">
                            {this.filterTargets()?.map(i => <li role="button" key={i.id} onClick={() => this.toggleTarget(i)} className={'list-group-item d-flex' + (this.getSelectedTarget(i.id) ? ' active' : '')}>
                                <input type="checkbox" className="d-block" checked={this.getSelectedTarget(i.id)} />
                                <div className="ms-2 flex-fill">
                                    {i.name}
                                </div>
                                <div className="ms-2">
                                    {i.code}
                                </div>
                            </li>)}
                        </ul>
                    </div>
                    {this.state.item?.targets?.length > 0 && <div className="mt-2">
                        <div className="mb-1">Selected Targets:</div>
                        {this.state.item?.targets?.map(i => <span key={i.id} className="badge bg-primary me-1 mb-1">{i.name} ({i.code}) <button type="button" className="btn-close" onClick={() => this.toggleTarget(i)}></button></span>)}
                    </div>}
                </Card>
                <Card title="Properties">
                    <FormInput model={this.state.item} name="standardTAT" label="Turn Around Time (In Hours)" type="number" step="1" onChange={this.change} placeholder="0" />
                </Card>
                <Card title="Settings">
                    <div className="row">
                        <div className="col-md-4">
                            <FormInput model={this.state.item} name="isOrderable" label="Orderable" type="switch" onChange={this.change} />
                            <small>Allow this panel to be ordered.</small>
                        </div>
                        <div className="col-md-4">
                            <FormInput model={this.state.item} name="isPatientOrderable" label="Patient Orderable" type="switch" onChange={this.change} />
                            <small>Allow patients to order this panel.</small>
                        </div>
                        <div className="col-md-4">
                            <FormInput model={this.state.item} name="isDisabled" label="Disable" type="switch" onChange={this.change} />
                            <small>Disable the panel completely from use.</small>
                        </div>
                    </div>
                </Card>
                <AppActions>
                    <button type="submit" className="btn btn-success btn-lg"><Icon icon="faSave" /> Save</button>
                </AppActions>
            </form>
        </div>;
    }
}

export default withParamsAndNavigate(PanelManageEdit);